import React, {Fragment} from 'react';
import {gql} from 'apollo-boost';
import {useQuery} from '@apollo/react-hooks';
import {useHistory, useParams} from 'react-router-dom';
import {Breadcrumbs, Loading} from 'worksource-ui';
import {Intent, Icon, Button} from '@blueprintjs/core';

import {showGQLError} from 'utils/toaster';
import HeaderBar from 'components/header-bar';
import withMainLayout from 'layouts/main/view';

const FETCH_GUIDES = gql`
  query GuidesIndexPageFetch($clientId: ID!) {
    guides(clientId: $clientId) {
      id,
      name,
    },
    currentUser @client {
      clients {
        id,
        role,
      },
    },
  }
`;

const ViewerGuidesIndexPage = () => {
  ////
  // Hooks
  //
  const {clientId} = useParams();
  const history = useHistory();

  ////
  // GraphQL
  //
  const {loading: loadingFetch, data} = useQuery(FETCH_GUIDES, {
    variables: {clientId},
    onError: error => showGQLError({error}),
  });

  ////
  // Render
  //
  if (loadingFetch || !data) {
    return (
      <Loading />
    );
  }

  const client = data.currentUser.clients.find(c => c.id === clientId);

  return (
    <Fragment>
      <HeaderBar>
        <Breadcrumbs>
          <Breadcrumbs.Breadcrumb
            current
            href={`/clients/${clientId}/guides`}
            icon="book"
            text="Guides"
          />
        </Breadcrumbs>
        <div className="spacer" />
        <Button
          intent={Intent.PRIMARY}
          text="Create Guide"
          icon="plus"
          onClick={() => {
            history.push(`/clients/${clientId}/guides/new`);
          }}
        />
      </HeaderBar>

      <div className="content-container">
        <div className="layout--full guides-index--container">
          {data.guides.map((guide) => {
            return <div
              className="guides-index--guide"
              key={guide.id}
              onClick={() => {
                if (client.role === 'admin') {
                  history.push(`/clients/${clientId}/guides/${guide.id}/edit`);
                } else {
                  history.push(`/clients/${clientId}/guides/${guide.id}`);
                }
              }}
            >
              <Icon icon="book" iconSize={72} />
              <div className="name">{guide.name}</div>
            </div>;
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default withMainLayout()(ViewerGuidesIndexPage);
